module.exports = __webpack_public_path__ + "src/assets/img/trafic_on.c9797b6d.svg";